import React from "react";
import { Link } from "react-router-dom";

function CasinoChip({ className }) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden>
      <defs>
        <linearGradient id="chipGold" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#ffe59a" /><stop offset="0.5" stopColor="#f5b400" /><stop offset="1" stopColor="#b97a00" />
        </linearGradient>
        <radialGradient id="chipCore" cx="40%" cy="35%" r="70%">
          <stop offset="0" stopColor="#3a0f16" /><stop offset="1" stopColor="#12050a" />
        </radialGradient>
      </defs>
      <circle cx="32" cy="32" r="29" fill="url(#chipGold)" />
      {[0, 45, 90, 135, 180, 225, 270, 315].map((a) => (
        <rect key={a} x="29" y="3.5" width="6" height="9" rx="1.5" fill="#12050a" transform={`rotate(${a} 32 32)`} />
      ))}
      <circle cx="32" cy="32" r="20" fill="url(#chipCore)" stroke="#ffe59a" strokeWidth="1.2" />
      <circle cx="32" cy="32" r="16" fill="none" stroke="#f5b400" strokeWidth="0.8" strokeDasharray="2.5 2.5" opacity="0.8" />
      <path d="M32 21c-3 5-8 7.5-8 12a5 5 0 0 0 7 4.6c-.3 2-1.2 3.4-3 4.4h8c-1.8-1-2.7-2.4-3-4.4a5 5 0 0 0 7-4.6c0-4.5-5-7-8-12z" fill="url(#chipGold)" />
    </svg>
  );
}

function CricketBat({ className }) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden>
      <defs>
        <linearGradient id="batGold" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#ffe59a" /><stop offset="1" stopColor="#c98c00" />
        </linearGradient>
        <radialGradient id="ballRed" cx="35%" cy="30%" r="75%">
          <stop offset="0" stopColor="#ff6b6b" /><stop offset="1" stopColor="#8f0d0d" />
        </radialGradient>
      </defs>
      <g transform="rotate(-22 32 32)">
        <rect x="29" y="3" width="7" height="20" rx="3" fill="#2a1a00" stroke="#f5b400" strokeWidth="1" />
        <path d="M31 8h3M31 12h3M31 16h3" stroke="#f5b400" strokeWidth="1" strokeLinecap="round" opacity="0.8" />
        <path d="M23 24q9-4 18 0v26q0 9-9 9t-9-9z" fill="url(#batGold)" stroke="#5a3b00" strokeWidth="1.3" strokeLinejoin="round" />
        <path d="M32 27v27" stroke="#8a5d00" strokeWidth="1" opacity="0.6" />
      </g>
      <circle cx="50" cy="50" r="8" fill="url(#ballRed)" stroke="#4a0606" strokeWidth="1" />
      <path d="M44.5 46c3 2.3 3 5.7 0 8M55.5 46c-3 2.3-3 5.7 0 8" fill="none" stroke="#ffd9d9" strokeWidth="1.1" strokeLinecap="round" />
    </svg>
  );
}

function SoccerBall({ className }) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden>
      <defs><radialGradient id="sb" cx="35%" cy="30%" r="75%"><stop offset="0" stopColor="#ffffff" /><stop offset="1" stopColor="#b8c2cc" /></radialGradient></defs>
      <circle cx="32" cy="32" r="29" fill="url(#sb)" stroke="#0f172a" strokeWidth="1.5" />
      <polygon points="32,20 42,27 38,39 26,39 22,27" fill="#0f172a" />
      <polygon points="32,3.5 42,27 32,20 22,27" fill="none" stroke="#0f172a" strokeWidth="1.8" strokeLinejoin="round" opacity="0.7" />
      <line x1="42" y1="27" x2="58" y2="22" stroke="#0f172a" strokeWidth="1.8" />
      <line x1="22" y1="27" x2="6" y2="22" stroke="#0f172a" strokeWidth="1.8" />
      <line x1="38" y1="39" x2="46" y2="55" stroke="#0f172a" strokeWidth="1.8" />
      <line x1="26" y1="39" x2="18" y2="55" stroke="#0f172a" strokeWidth="1.8" />
      <polygon points="58,22 60,36 50,42 46,55" fill="none" stroke="#0f172a" strokeWidth="1.8" opacity="0.6" />
      <polygon points="6,22 4,36 14,42 18,55" fill="none" stroke="#0f172a" strokeWidth="1.8" opacity="0.6" />
    </svg>
  );
}

function TennisBall({ className }) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden>
      <defs><radialGradient id="tb" cx="35%" cy="30%" r="75%"><stop offset="0" stopColor="#eaff6b" /><stop offset="1" stopColor="#8fb300" /></radialGradient></defs>
      <circle cx="32" cy="32" r="29" fill="url(#tb)" stroke="#5a7300" strokeWidth="1.5" />
      <path d="M12 8 C 30 22, 30 42, 12 56" fill="none" stroke="#ffffff" strokeWidth="3.2" strokeLinecap="round" />
      <path d="M52 8 C 34 22, 34 42, 52 56" fill="none" stroke="#ffffff" strokeWidth="3.2" strokeLinecap="round" />
    </svg>
  );
}

function Tile({ to, label, active, badge, live, testid, children }) {
  const Comp = to ? Link : "div";
  return (
    <Comp to={to} data-testid={testid}
      className="group relative flex flex-col items-center snap-center w-[64px] shrink-0 select-none transition-transform duration-150 active:scale-[0.96]">
      <span className={`relative grid place-items-center h-[56px] w-[64px] rounded-[14px] border bg-[linear-gradient(180deg,#1A1A1F_0%,#0D0D10_100%)] transition-[border-color,box-shadow] duration-150
        ${active ? "border-[#F5B81C] shadow-[0_0_12px_rgba(245,184,28,0.35),inset_0_1px_0_rgba(255,255,255,0.08)]" : "border-[rgba(245,184,28,0.35)] shadow-[inset_0_1px_0_rgba(255,255,255,0.06)]"}`}>
        <span className="pointer-events-none absolute inset-0 rounded-[14px] bg-[radial-gradient(100%_60%_at_50%_0%,rgba(255,255,255,0.07),transparent_60%)]" />
        <span className="relative drop-shadow-[0_2px_4px_rgba(0,0,0,0.6)]">{children}</span>
        {(live || badge != null) && (
          <span className={`absolute -top-1.5 -right-1.5 inline-flex items-center gap-1 rounded-full bg-[#0D0D10] ring-1 ring-[rgba(245,184,28,0.45)] ${badge != null ? "h-[16px] px-1.5" : "h-[14px] w-[14px] justify-center"}`}
            data-testid={badge != null ? `${testid}-count` : `${testid}-live`}>
            <span className="relative flex h-[7px] w-[7px]">
              <span className="absolute inline-flex h-full w-full rounded-full bg-[#e53935] opacity-75 animate-ping" />
              <span className="relative inline-flex h-[7px] w-[7px] rounded-full bg-[#ff3b30]" />
            </span>
            {badge != null && <span className="text-[10px] font-bold text-white leading-none tabular-nums">{badge}</span>}
          </span>
        )}
      </span>
      <span className={`mt-1.5 text-[11px] uppercase tracking-[0.8px] leading-none transition-colors duration-150 ${active ? "text-[#F5B81C] font-bold" : "text-[#d8d6cf] font-semibold"}`}>
        {label}
      </span>
      {active && <span className="mt-1 h-[2px] w-5 rounded-full bg-[#F5B81C]" />}
    </Comp>
  );
}

export default function SportIconRow({ liveCount }) {
  return (
    <div className="relative bbw-carpet h-[84px]" data-testid="sport-icon-row">
      <div className="flex items-start justify-around gap-[10px] px-3 pt-2 overflow-x-auto snap-x snap-mandatory no-scrollbar">
        <Tile to="/live-casino" label="Casino" live testid="sport-tile-casino">
          <CasinoChip className="h-[26px] w-[26px]" />
        </Tile>
        <Tile label="Cricket" active badge={liveCount || null} testid="sport-tile-cricket">
          <CricketBat className="h-[26px] w-[26px]" />
        </Tile>
        <Tile label="Soccer" testid="sport-tile-soccer">
          <SoccerBall className="h-[26px] w-[26px]" />
        </Tile>
        <Tile label="Tennis" testid="sport-tile-tennis">
          <TennisBall className="h-[26px] w-[26px]" />
        </Tile>
      </div>
    </div>
  );
}
